import { render } from "./Impressum.vue?vue&type=template&id=e8de3610"
import script from "./Impressum.vue?vue&type=script&lang=js"
export * from "./Impressum.vue?vue&type=script&lang=js"

import "./Impressum.vue?vue&type=style&index=0&id=e8de3610&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__